module.exports = vendor_lib;


//////////////////
// WEBPACK FOOTER
// external "vendor_lib"
// module id = 3
// module chunks = 0